import when from 'when';
import rest from 'rest';
import has from 'lodash/has';
import includes from 'lodash/includes';
import { normalize } from 'normalizr';

import * as requestMethodTypes from '../../constants/requestMethods';
import { ACLQueryModeTypes } from '../../constants/visibilityFilters';
import JSONUtils from '../../lib/JSONUtils';
import LocalStorageUtils from '../../lib/LocalStorageUtils';

const versionInfo = {
  version: process.env.REACT_APP_VERSION || '0.0.0',
  versionHash: process.env.REACT_APP_VERSION_HASH || 'local',
  environment: process.env.NODE_ENV || 'production',
};

const APP_CLIENT_INFO = `nexla-ui/${versionInfo.version} (Web; ${versionInfo.versionHash}) ${navigator.userAgent}`;

export const callAuthAPI = (
  endpoint,
  requestMethod = requestMethodTypes.POST,
  aclQueryMode = ACLQueryModeTypes.MODE_OWNER.key,
  payload = null,
  schema = null,
) => {
  let requestHeaders = {
    Accept: 'application/vnd.nexla.api.v1+json',
    'Content-Type': 'application/json',
    'X-Nexla-Client-Info': APP_CLIENT_INFO,
    'X-Nexla-App-Version': versionInfo.version,
    'X-Nexla-App-Hash': versionInfo.versionHash,
    // 'cache-control': 'no-store no-cache'
  };

  //payload params need to be added to the request headers
  let isGoogleUser = false;
  let requestEntity;
  if (has(payload, 'username') && has(payload, 'password')) {
    requestHeaders['Authorization'] = `Basic ${payload.username}:${payload.password}:*`;
  } else if (has(payload, 'gToken')) {
    isGoogleUser = true;
    requestHeaders['Authorization'] = `Bearer ${payload.gToken}`;
    if (payload.self_signup) {
      requestEntity = JSON.stringify({ self_signup: payload.self_signup });
    }
  } else if (has(payload, 'org_id')) {
    // When switching Org, we need to set authorization header
    requestHeaders['Authorization'] = `Bearer ${payload.accessToken}`;
    requestEntity = JSON.stringify({ org_id: payload.org_id });
  } else if (has(payload, 'accessToken')) {
    isGoogleUser = has(payload, 'isGoogleUser') ? payload.isGoogleUser : false;
    requestHeaders['Authorization'] = `Bearer ${payload.accessToken}`;
  } else if (payload) {
    requestEntity = JSON.stringify(payload);
  }

  return when(
    rest({
      path: endpoint,
      method: requestMethod,
      crossOrigin: true,
      headers: requestHeaders,
      entity: requestEntity,
    }),
  ).then(
    (response) => {
      if (response.status.code >= 400) {
        // console.log('rsp error api call');
        // console.log(response);
        return Promise.reject(response);
      } else if (
        has(response, 'headers["Content-Type"]') &&
        !includes(response.headers['Content-Type'], 'application/json') &&
        !includes(response.headers['Content-Type'], 'application/vnd.nexla.api.v1+json')
      ) {
        console.log('did not get json response!');
        return Promise.reject(
          new Error('Sorry, request could not be completed. Please try again.'),
        );
      }

      //extract data from response
      let responseHeaders = has(response, 'headers') ? response.headers : {};
      if (has(response, 'entity') && response.entity) {
        let responseJSON = JSONUtils.parseJson(response.entity);

        if (schema) {
          let normalizedSessionInfo = normalize(responseJSON, schema);

          LocalStorageUtils.saveObject('nexSession', {
            ...normalizedSessionInfo,
            isGoogleUser,
          });

          return { rsp: normalizedSessionInfo, rspHeaders: responseHeaders };
        }

        return { rsp: responseJSON, rspHeaders: responseHeaders };
      }

      return null;
    },
    (err) => {
      //console.log('rsp err');
      return Promise.reject(err);
    },
  );
};
